import { FileRegistrationModel } from '../../../models/applicationRegistration/fileRegistration/fileRegistrationModel'
import { FilterModel } from '../../../models/utils/filterModel'
import apiService from '../../api/apiManager'

class GsiDataService {
  async apiFetchGsiList(filterData: FilterModel) {
    return apiService.apiPost(
      `/compensation-recommendation/compensation/gsi/view/list`,
      filterData
    )
  }

  async apiFetchGsiListCount(filterData: FilterModel) {
    return apiService.apiPost(
      `/compensation-recommendation/compensation/gsi/view/count`,
      filterData
    )
  }

  async apiFetchGsiReturnList(filterData: FilterModel) {
    return apiService.apiPost(
      `/compensation-recommendation/compensation/gsi/file-return/view/list`,
      filterData
    )
  }

  async apiFetchGsiReturnListCount(filterData: FilterModel) {
    return apiService.apiPost(
      `/compensation-recommendation/compensation/gsi/file-return/view/count`,
      filterData
    )
  }

  async apiApproveGsiFile(id: number) {
    return apiService.apiPutCommon(
      `/compensation-recommendation/compensation/gsi/${id}/approve`,
      {}
    )
  }

  async apiRejectGsiFile(id: number, remark: string) {
    return apiService.apiPutCommon(
      `/compensation-recommendation/compensation/gsi/${id}/reject`,
      { remark: remark }
    )
  }
  async apiReturnGsiFile(id: number, remark: string) {
    return apiService.apiPutCommon(
      `/compensation-recommendation/compensation/gsi/${id}/return`,
      { remark: remark }
    )
  }
  async apiUpdateGsiFile(id: number, file: FileRegistrationModel) {
    return apiService.apiPutCommon(
      `/compensation-recommendation/compensation/gsi/file-return/${id}`,
      file
    )
  }
  async apiGetReturnGsiFile(id: number) {
    return apiService.apiGet(
      `/compensation-recommendation/compensation/gsi/file-return/view/${id}`
    )
  }
  async apiGetGsiFile(id: number) {
    return apiService.apiGet(
      `/compensation-recommendation/compensation/gsi/view/${id}`
    )
  }
}

export default new GsiDataService()
